__webpack_require__.p = "/addon-app/space/platform/releases/v2.36.4/767c1e4/";